import { gql } from '@apollo/client';
import React from 'react';
import { ModuleSectionFragment } from '../generated/types/ModuleSectionFragment';
import { DividerPumoModule, DIVIDER_PUMO_MODULE_FRAGMENT } from './DividerPumoModule';
import { SinglePumoModule, SINGLE_PUMO_MODULE_FRAGMENT } from './SinglePumoModule';
import { MultiPumoModule, MULTI_PUMO_MODULE_FRAGMENT } from './MultiPumoModule';
import {
  HomePageHeaderPumoModule,
  HOMEPAGE_HEADER_PUMO_MODULE_FRAGMENT
} from './HomePageHeaderPumoModule';
import { CarouselPumoModule, CAROUSEL_PUMO_MODULE_FRAGMENT } from './CarouselPumoModule';
import {
  RecommendationsPumoModule,
  RECOMMENDATIONS_PUMO_MODULE_FRAGMENT
} from './RecommendationsPumoModule';
import { EmailPumoModule, EMAIL_PUMO_MODULE_FRAGMENT } from './EmailPumoModule';
import { PillsPumoModule, PILLS_PUMO_MODULE_FRAGMENT } from './PillsPumoModule';
import {
  TrunkshowCountdownPumoModule,
  TRUNKSHOW_COUNTDOWN_PUMO_MODULE_FRAGMENT
} from './TrunkshowCoundownPumoModule';
import { PumoLivestreamModule, PUMO_LIVESTREAM_MODULE_FRAGMENT } from './PumoLivestreamModule';

export const MODULE_SECTION_FRAGMENT = gql`
  fragment ModuleSectionFragment on PumoModule {
    __typename
    ... on LivestreamPumoModule {
      id
    }
    ... on DividerPumoModule {
      id
    }
    ... on SinglePumoModule {
      id
    }
    ... on MultiPumoModule {
      id
    }
    ... on CarouselPumoModule {
      id
    }
    ... on RecommendationsPumoModule {
      id
    }
    ... on HomePageHeaderPumoModule {
      id
    }
    ... on EmailPumoModule {
      id
    }
    ... on PillsPumoModule {
      id
    }
    ... on TrunkshowCountdownPumoModule {
      id
    }
    ...CarouselPumoModuleFragment
    ...DividerPumoModuleFragment
    ...EmailPumoModuleFragment
    ...HomePageHeaderPumoModuleFragment
    ...MultiPumoModuleFragment
    ...PillsPumoModuleFragment
    ...RecommendationsPumoModuleFragment
    ...SinglePumoModuleFragment
    ...TrunkshowCountdownPumoModuleFragment
    ...PumoLivestreamModuleFragment
  }
  ${CAROUSEL_PUMO_MODULE_FRAGMENT}
  ${DIVIDER_PUMO_MODULE_FRAGMENT}
  ${EMAIL_PUMO_MODULE_FRAGMENT}
  ${HOMEPAGE_HEADER_PUMO_MODULE_FRAGMENT}
  ${MULTI_PUMO_MODULE_FRAGMENT}
  ${PILLS_PUMO_MODULE_FRAGMENT}
  ${RECOMMENDATIONS_PUMO_MODULE_FRAGMENT}
  ${SINGLE_PUMO_MODULE_FRAGMENT}
  ${TRUNKSHOW_COUNTDOWN_PUMO_MODULE_FRAGMENT}
  ${PUMO_LIVESTREAM_MODULE_FRAGMENT}
`;

export interface Props {
  modules: ModuleSectionFragment[];
}

export const ModuleSection: React.FC<Props> = ({ modules }) => {
  return (
    <section className="PumoModule">
      {modules.map(moduleSection => {
        const key = [moduleSection.__typename, moduleSection.id].join(':');

        switch (moduleSection.__typename) {
          case 'DividerPumoModule':
            return <DividerPumoModule key={key} dividerPumoModule={moduleSection} />;
          case 'SinglePumoModule':
            return <SinglePumoModule key={key} singlePumoModule={moduleSection} />;
          case 'MultiPumoModule':
            return <MultiPumoModule key={key} multiPumoModule={moduleSection} />;
          case 'HomePageHeaderPumoModule':
            return <HomePageHeaderPumoModule key={key} homePageHeaderPumoModule={moduleSection} />;
          case 'CarouselPumoModule':
            return <CarouselPumoModule key={key} carouselPumoModule={moduleSection} />;
          case 'RecommendationsPumoModule':
            return (
              <RecommendationsPumoModule key={key} recommendationsPumoModule={moduleSection} />
            );
          case 'EmailPumoModule':
            return <EmailPumoModule key={key} emailPumoModule={moduleSection} />;
          case 'PillsPumoModule':
            return <PillsPumoModule key={key} pillsPumoModule={moduleSection} />;
          case 'TrunkshowCountdownPumoModule':
            return (
              <TrunkshowCountdownPumoModule
                key={key}
                trunkshowCountdownPumoModule={moduleSection}
              />
            );
          case 'LivestreamPumoModule':
            return <PumoLivestreamModule key={key} livestream={moduleSection} />;
        }
      })}
    </section>
  );
};
